import { Column } from '@tanstack/react-table';

type cellStyles = {
  position?: 'sticky';
  left?: number | string;
  right?: number | string;
};

const getCommonCellStyles = ({ column }: { column: Column<unknown, unknown> }) => {
  const styles: cellStyles = {
    position: column?.getIsPinned() ? 'sticky' : undefined,
    left: column?.getIsPinned() === 'left' ? `${column?.getStart('left')}px` : undefined,
    right: column?.getIsPinned() === 'right' ? `${column?.getAfter('right')}px` : undefined,
  };

  return {
    styles: styles,
  };
};

export { getCommonCellStyles };
